import { Flex, Text } from '@fluentui/react-northstar';
import React from 'react';
import { useTranslation } from 'react-i18next';
import AffectedUserIcon from '../../../../svg/affected-user.svg';
import ApprovalsSVG from '../../../../svg/approval-detail-card.svg';
import AttachmentIcon from '../../../../svg/attachment.svg';
import CollaboratorIcon from '../../../../svg/collaboratorIcon.svg';
import CommentsIcon from '../../../../svg/comments-filled-icon.svg';
import TaskSVG from '../../../../svg/task-icon.svg';
import { LICENSE_FEATURE } from '../../utils/constants';
import { CheckFeature } from '../CheckFeature';
import { UsersTooltip } from './UsersTooltip';

interface Props {
  ticketData: any;
  globalTheme: any;
  attachmentsCount?: number;
  commentsCount?: number;
  detailCardApprovalsList?: TicketApprovals[];
  detailCardTaskList?: TicketTask[];
}

/** The count cluster on the right of the ticket card's footer, shared with the collapsed bar. */
export const TicketDetailCounters = ({
  ticketData,
  globalTheme,
  attachmentsCount,
  commentsCount,
  detailCardApprovalsList,
  detailCardTaskList
}: Props) => {
  const { t } = useTranslation();
  const foreground = globalTheme.siteVariables.colorScheme.default.foreground;
  return (
    <span className="flex items-center gap-1">
      <CheckFeature featureName={LICENSE_FEATURE.Collaborators}>
        <Flex vAlign="center">
          <CollaboratorIcon width={12} height={12} style={{ margin: '0 auto', color: foreground }} />
          <UsersTooltip ticketCollaborator={ticketData?.TicketCollaborators.map(c => c.PlatformUser)} title={t('ticket.ticket-list.collaborators')} />
        </Flex>
      </CheckFeature>

      <CheckFeature featureName={LICENSE_FEATURE.AffectedUsers}>
        <Flex vAlign="center">
          <AffectedUserIcon width={12} height={12} style={{ margin: '0 auto', color: foreground }} />
          <UsersTooltip ticketCollaborator={ticketData?.AffectedUsers.map(c => c.PlatformUser)} title={t('ticket.ticket-list.affected-users')} />
        </Flex>
      </CheckFeature>

      <Flex vAlign="center" className='gap-0.5'>
        <AttachmentIcon width={12} height={12} style={{ margin: '0 auto', color: foreground }} />
        <Text size="small" style={{ color: foreground, marginLeft: '4px' }}>
          {attachmentsCount ?? 0}
        </Text>
      </Flex>

      <Flex vAlign="center" className='gap-0.5'>
        <CommentsIcon width={12} height={12} style={{ margin: '0 auto', color: foreground }} />
        <Text size="small" style={{ color: foreground, marginLeft: '4px' }}>
          {commentsCount ?? 0}
        </Text>
      </Flex>
      <CheckFeature featureName={LICENSE_FEATURE.Approvals}>
        <Flex vAlign="center" className='gap-0.5'>
          <ApprovalsSVG
            width={12}
            height={12}
            style={{ margin: '0 auto' }}
            className={``}
          />
          <Text size="small" style={{ color: foreground, marginLeft: '4px' }}>
            {detailCardApprovalsList?.length ?? 0}
          </Text>
        </Flex>
      </CheckFeature>

      <CheckFeature featureName={LICENSE_FEATURE.TicketTasks}>
        <Flex vAlign="center" className='gap-0.5'>
          <TaskSVG
            width={12}
            height={12}
            style={{ margin: '0 auto' }}
            className={``}
          />
          <Text size="small" style={{ color: foreground, marginLeft: '4px' }}>
            {detailCardTaskList?.length ?? 0}
          </Text>
        </Flex>
      </CheckFeature>

    </span>
  );
};
